import React from "react"
import { HeaderSection } from "../../common/headers/HeaderSection";
import FreeCourseScheduleSection from "./FreeCourseBanner";
import { CourseSchedule } from "@/interfaces/CourseSchedule";

const frontendWeek1FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 1,
        programTitle: 'Front-End Website',
        date: '7 Desember 2023',
        day: 'Kamis',
        time: '19.00 - selesai',
    },
];
const frontendWeek2FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 2,
        programTitle: 'Front-End Website',
        date: '20 Desember 2023',
        day: 'Rabu',
        time: '19.00 - selesai',
    },
];
const frontendWeek3FreeCourseSchedule: CourseSchedule[] = [
    {
        id: 3,
        programTitle: 'Front-End Website',
        date: '27 Desember 2023',
        day: 'Rabu',
        time: '19.00 - selesai',
    },
];

const FrontEndFreeCourseSchedule = () => {
    return (
        <div className="px-5 md:px-10">
            <HeaderSection
                title="Jadwal Program"
                subtitle="Pilih dan daftar jadwal program yang tersedia"
            />
            <FreeCourseScheduleSection schedule={frontendWeek1FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={frontendWeek2FreeCourseSchedule} />
            <FreeCourseScheduleSection schedule={frontendWeek3FreeCourseSchedule} />
        </div>
    );
};

export default FrontEndFreeCourseSchedule;